/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Guide_ToggleInputs */

const en_us2_body_assessment_guide_toggle = /** @type {(inputs: Body_Assessment_Guide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide`)
};

const pt_br2_body_assessment_guide_toggle = /** @type {(inputs: Body_Assessment_Guide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia`)
};

const es_419_body_assessment_guide_toggle = /** @type {(inputs: Body_Assessment_Guide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guía`)
};

const pt_pt2_body_assessment_guide_toggle = /** @type {(inputs: Body_Assessment_Guide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guia`)
};

const fr_fr2_body_assessment_guide_toggle = /** @type {(inputs: Body_Assessment_Guide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guide`)
};

const de_de2_body_assessment_guide_toggle = /** @type {(inputs: Body_Assessment_Guide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfe`)
};

const it_it2_body_assessment_guide_toggle = /** @type {(inputs: Body_Assessment_Guide_ToggleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida`)
};

/**
* | output |
* | --- |
* | "Guide" |
*
* @param {Body_Assessment_Guide_ToggleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_guide_toggle = /** @type {((inputs?: Body_Assessment_Guide_ToggleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Guide_ToggleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_guide_toggle(inputs)
	if (locale === "es-419") return es_419_body_assessment_guide_toggle(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_guide_toggle(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_guide_toggle(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_guide_toggle(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_guide_toggle(inputs)
	return en_us2_body_assessment_guide_toggle(inputs)
});
export { body_assessment_guide_toggle as "body-assessment.guide_toggle" }